import Index from "../../pages/snail/riverMountain-3/index";
import Index2 from "../../pages/snail/xihu-3/index";

const base = "riverMountain-3";
const base2 = "xihu-3";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base2}/enter*`,
    name: `${base2}-enter`,
    component: Index2
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/riverMountain-3.js